import React, { useState } from 'react'
import Layout from '../../Layout'
import { Button, Input } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import Container from '../../components/Container';
import { useNavigate } from 'react-router-dom';
// import { AvatarPreview } from "../../components/Uploader";
import { useAppSelector } from '../../store';

import { createLab } from "../../api/lab";
import { toast } from 'react-toastify';

function NewLab() {
  const userData = useAppSelector((state) => state.userData);

  const navigate = useNavigate();

  const [labNmae, setLabName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!labNmae.trim()) {
      toast.error("Lab Name is required");
      return;
    }

    const data = {
      name: labNmae,
    };

    setLoading(true);
    const response = await createLab(data);
    if (response) {
      setLoading(false);
      setLabName("");
      navigate("/");
    }
    setLoading(false);
  };

  return (
    <Layout>
      <Container className={'rounded-lg'}>
        <div className="grid col-span-12">
          <div className="w-full text-center text-lg mt-1 mb-4">Please enter your lab name</div>
          <Input label={'Lab Name *'} name={'name'} color placeholder={'Lab Name'} type={'text'} value={labNmae} onChange={(e) => setLabName(e.target.value)} />
          <Button label={'CREATE A NEW LAB'} color Icon={FaSave} onClick={handleSubmit} loading={loading} />
          <div className="w-full text-center my-2">or</div>
          <Button className={'w-full bg-transparent !text-subMain'} label={'JOIN EXISTING LAB'} onClick={() => navigate("/invitation")} />
        </div>
      </Container>
    </Layout>
  )
}

export default NewLab